import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { Validator } from "Utils/validator";
import { toast } from "react-toastify";
import { ButtonLoader } from "Components";
import { newAuthService } from "Service/Axios";
import { saveUserProfileUrl } from "Constant/api";
import { VIEW_PROFILE_SECTIONS } from "Constant/constants";

export const ResearchSummaryModal = ({
  show,
  researchSummaryData,
  toggle,
  fetchData,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    researchSummary: "",
  });
  const [errMsg, setErrMsg] = useState({
    researchSummary: "",
  });

  const { researchSummary } = formData;

  useEffect(() => {
    if (researchSummaryData) {
      setFormData((prev) => ({
        ...prev,
        researchSummary: researchSummaryData,
      }));
    }
  }, [researchSummaryData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (!Validator.text(value)) {
      setErrMsg((prev) => ({
        ...prev,
        [name]: t("common.messages.error.viewProfile.researchSummary.blank"),
      }));
    } else {
      setErrMsg((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const getValidation = () => {
    return new Promise((resolve) => {
      let isValid = true;
      const errors = {};

      if (!Validator.text(researchSummary)) {
        errors.researchSummary = t(
          "common.messages.error.viewProfile.researchSummary.blank"
        );
        isValid = false;
      }

      setErrMsg((prev) => ({
        ...prev,
        ...errors,
      }));

      resolve(isValid);
    });
  };

  const onSaveResearchSummary = async () => {
    const validationStatus = await getValidation();
    if (validationStatus) {
      try {
        const payload = {
          key: VIEW_PROFILE_SECTIONS.researchSummary,
          [VIEW_PROFILE_SECTIONS.researchSummary]: researchSummary,
        };

        setLoading(true);
        const response = await newAuthService(
          saveUserProfileUrl,
          "POST",
          payload
        );
        if (response.status) {
          toast.success(
            t("common.messages.notification.success.profileUpdated")
          );
          fetchData();
          toggle();
        } else {
          toast.error(response.message);
        }
      } catch {
        toast.error(
          t("common.messages.notification.failed.somethingWentWrong")
        );
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <Modal show={show} onHide={toggle} className="highlightsModal">
      <Modal.Header closeButton>
        <Modal.Title className="text-md font-medium">
          {t("auth.viewProfile.editResearchSummary")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          <div className="col-12">
            <div className="mb-3">
              <textarea
                className="form-control"
                id="researchSummary"
                name="researchSummary"
                placeholder={t("common.placeHolder.researchSummary")}
                value={researchSummary}
                onChange={handleChange}
                rows={8}
              />
              {errMsg.researchSummary && (
                <p className="error">{errMsg.researchSummary}</p>
              )}
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light" onClick={toggle}>
          {t("common.button.cancel")}
        </Button>
        {loading ? (
          <ButtonLoader />
        ) : (
          <Button variant="primary" onClick={onSaveResearchSummary}>
            {t("common.button.save")}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};
